import React from 'react'
import PropTypes from 'prop-types'
import { Instagram } from '@styled-icons/boxicons-logos/Instagram'
import { Facebook } from '@styled-icons/boxicons-logos/Facebook'
import { Youtube } from '@styled-icons/boxicons-logos/Youtube'
import { Linkedin } from '@styled-icons/boxicons-logos/Linkedin'
import * as S from './styled'

const SocialFooter = ({ socialLinks }) => {
  const {
    facebook_url: facebookUrl,
    instagram_url: instagramUrl,
    linkedin_url: linkedinUrl,
    youtube_url: youtubeUrl,
  } = socialLinks

  return (
    <S.SocialFooterContainer data-testid='footer-socials'>
      <S.IconsContainer>
        {facebookUrl !== '' && (
          <S.SocialLink data-testid='footer-facebook' href={facebookUrl} target="_blank" rel="noreferrer">
            <Facebook size={24} />
          </S.SocialLink>
        )}
        {youtubeUrl !== '' && (
          <S.SocialLink data-testid='footer-youtube' href={youtubeUrl} target="_blank" rel="noreferrer">
            <Youtube size={24} />
          </S.SocialLink>
        )}
        {linkedinUrl !== '' && (
          <S.SocialLink data-testid='footer-linkedin' href={linkedinUrl} target="_blank" rel="noreferrer">
            <Linkedin size={24} />
          </S.SocialLink>
        )}
        {instagramUrl !== '' && (
          <S.SocialLink data-testid='footer-instagram' href={instagramUrl} target="_blank" rel="noreferrer">
            <Instagram size={24} />
          </S.SocialLink>
        )}
      </S.IconsContainer>
    </S.SocialFooterContainer>
  )
}

SocialFooter.propTypes = {
  socialLinks: PropTypes.object,
}

export default SocialFooter
